import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getBookingsList = (bookingData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BOOKINGS_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/booking/list`,
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_BOOKINGS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_BOOKINGS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_BOOKINGS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getBookingsListPaymentExecutive = (bookingData, id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BOOKINGS_LIST_PAYMENT_EXEC_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/booking/payment-executive/${id}`,
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_BOOKINGS_LIST_PAYMENT_EXEC_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "GET_BOOKINGS_LIST_PAYMENT_EXEC_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_BOOKINGS_LIST_PAYMENT_EXEC_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getBookingsListById = (bookingData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BOOKING_REQUEST" });
      const { data } = await axios.get(
        `${BASE_URL}/booking/${bookingData}`,
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_BOOKING_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_BOOKING_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_BOOKING_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addRewardPoints = (rewardData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REWARD_POINTS_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/reward-user/add-reward-points`,
        rewardData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REWARD_POINTS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "ADD_REWARD_POINTS_FAILED", payload: data });
        return data
      }
    } catch (error) {
      dispatch({
        type: "ADD_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const getPaymentExecutiveList = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PAYMENT_EXECUTIVE_LIST_REQUEST" });
      
      const { data } = await axios.post(
        `${BASE_URL}/booking/payment-executive-list`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      if (data.statusCode === 200) {
        dispatch({
          type: "GET_PAYMENT_EXECUTIVE_LIST_SUCCESS",
          payload: data,
        });
        console.log("API response data:", data);
      } else {
        dispatch({
          type: "GET_PAYMENT_EXECUTIVE_LIST_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_PAYMENT_EXECUTIVE_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const cancelBooking = (cancelData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "CANCEL_BOOKING_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/booking/cancel`,
        cancelData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "CANCEL_BOOKING_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "CANCEL_BOOKING_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CANCEL_BOOKING_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateLegalDocuments = (updateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_LEGAL_DOCUMENTS_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/booking/update-legal-documents`,
        updateData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_LEGAL_DOCUMENTS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "UPDATE_LEGAL_DOCUMENTS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_LEGAL_DOCUMENTS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
